import { gql } from 'graphql-request';

// Query keys for TanStack Query
export const GET_CUSTOMER_DRAWER_QUERY_KEY = 'GET_CUSTOMER_DRAWER_QUERY';
export const GET_VEHICLE_DRAWER_QUERY_KEY = 'GET_VEHICLE_DRAWER_QUERY';

/**
 * Lightweight query for customer drawer view
 * Fetches only essential information needed for the drawer
 */
export const GET_CUSTOMER_DRAWER_QUERY = gql`
  query GetCustomerDrawer($id: ID!) {
    customer {
      contact(id: $id) {
        id
        name
        firstName
        lastName
        personalNumber
        tags
        contactInfos {
          id
          isPrimary
          contactInfo {
            id
            type
            value
            category
          }
        }
        addresses {
          id
          type
          street
          city
          postalCode
          country
          isPrimary
        }
      }
    }
  }
`;

/**
 * Lightweight query for vehicle drawer view
 * Fetches only essential information needed for the drawer
 */
export const GET_VEHICLE_DRAWER_QUERY = gql`
  query GetVehicleDrawer($itemID: String!) {
    item(itemID: $itemID) {
      ... on Iteration {
        id
        displayName
        registrationNumber
        makeModel {
          id
          make
          model
        }
        modelYear
        mileage {
          value
          unit
        }
        price {
          price
        }
        status
        images {
          id
          url
        }
      }
    }
  }
`;
